import { Asset } from '@/types/asset';
import AssetClient from './clients/assets-client';

export default {
  getAssetInfo() {
    return AssetClient.getAssetInfo().then(({ assets, currencies, blockchains }) => {
      return assets.map(({ id, name,  decimals, blockchain, currency, network, type }): Asset => {
        const blockchainInfo = blockchains.find(item => item.id === blockchain);

        return {
          id,
          name,
          decimals,
          type: type ?? null,
          blockchain: blockchainInfo ?? {
            id: blockchain,
            name: blockchain,
          },
          currency: currencies.find(item => item.code === currency) ?? {
            code: currency,
            name: currency,
          },
          network: network && blockchainInfo?.network ? blockchainInfo.network[network] : null,
        };
      });
    });
  },
};
